// Compiled at 2026-10-07T06:21:14.844Z
// Compiled at 2026-10-07T06:21:14.844Z
// Compiled at 2026-10-07T06:21:14.844Z
// Auto-generated by Lowgile
export const BranchName = 'master';
const { enUS } = require('date-fns/locale')
export const AppModuleId = 'Toolbox', Languages = { "English": { "isoCode": "en-US", "shortName": "en", "displayName": "English" } }, DefaultLanguage = "English", DefaultScreen = ["Toolbox", "Home"] as [string, string], DateFnsLocales = { enUS };
